import React from 'react'

interface IGridProps {
  children: React.ReactNode
  gap?: string | number
  columns?: string
  rows?: string
}

const Grid: React.FC<IGridProps> = ({ children, gap, columns, rows }) => (
  <div
    className='grid'
    style={{
      gridGap: gap,
      gridTemplateColumns: columns,
      gridTemplateRows: rows
    }}
  >
    {children}
  </div>
)

export default Grid
